import Techbridge1 from "../../../assets/Techbridge-1.jpg";
import Techbridge2 from "../../../assets/Techbridge-2.jpg";

export default function Hero() {
  return (
    <section id="home" className="relative pt-[88px] md:pt-[96px] min-h-[650px] md:min-h-[750px] flex items-center overflow-hidden">
      {/* Full banner background image */}
      <div className="absolute inset-0">
        <img
          src={Techbridge1}
          alt="TechBridge IT Infrastructure"
          className="w-full h-full object-cover"
        />
        {/* Dark gradient overlay for text readability */}
        <div className="absolute inset-0 bg-gradient-to-r from-black/85 via-black/65 to-black/50"></div>
        {/* Subtle tech grid pattern overlay */}
        <div className="absolute inset-0 opacity-[0.04]" style={{
          backgroundImage: 'linear-gradient(rgba(1,103,248,0.3) 1px, transparent 1px), linear-gradient(90deg, rgba(1,103,248,0.3) 1px, transparent 1px)',
          backgroundSize: '60px 60px',
        }}></div>
      </div>

      <div className="relative z-10 w-full max-w-site mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center lg:items-center gap-10 lg:gap-16 py-16 md:py-20 lg:py-0">
          {/* Left: Text content */}
          <div className="flex-1 w-full lg:max-w-[580px] animate-on-scroll">
            <div className="inline-flex items-center gap-2 mb-6">
              <span className="w-2 h-2 rounded-full flex-shrink-0 bg-primary-500"></span>
              <span className="font-label text-xs uppercase tracking-[0.2em] text-white/70">Complete IT Solutions</span>
            </div>

            <h1 className="font-heading text-[42px] md:text-[64px] lg:text-[72px] leading-[1.08] font-bold text-white tracking-[-0.02em]">
              Technology that<br />
              keeps your business<br />
              <span style={{ color: '#0167F8' }}>moving.</span>
            </h1>

            <p className="mt-6 md:mt-8 text-base md:text-lg text-white/75 leading-relaxed max-w-[540px]">
              From hardware and networking to computers, printers and ongoing IT support,
              TechBridge provides the technology your business needs to stay connected,
              productive and supported.
            </p>

            <div className="mt-8 md:mt-10 flex flex-col sm:flex-row items-start sm:items-center gap-4">
              <a
                href="#contact"
                onClick={(e) => { e.preventDefault(); document.querySelector('#contact')?.scrollIntoView({ behavior: 'smooth' }); }}
                className="whitespace-nowrap inline-flex items-center gap-2 rounded-xl font-label text-sm font-semibold transition-all duration-300 cursor-pointer group hover:shadow-xl hover:shadow-primary-500/30 hover:-translate-y-0.5"
                style={{ backgroundColor: '#0167F8', color: '#FFFFFF', padding: '14px 28px' }}
              >
                Get IT Support
                <i className="ri-arrow-right-line transition-transform duration-200 group-hover:translate-x-1"></i>
              </a>
              <a
                href="tel:+919940148039"
                className="whitespace-nowrap inline-flex items-center gap-2 rounded-xl font-label text-sm font-semibold text-white border border-white/25 hover:border-primary-500 hover:bg-white/10 transition-all duration-300 cursor-pointer"
                style={{ padding: '14px 28px' }}
              >
                <i className="ri-phone-line"></i>
                +91 99401 48039
              </a>
            </div>

            <div className="mt-8 pt-6 border-t border-white/15 flex flex-wrap items-center gap-x-5 gap-y-2">
              {['IT Hardware', 'Networking', 'Computers', 'Printers', 'AMC Support'].map((item) => (
                <span key={item} className="font-label text-xs text-white/50 whitespace-nowrap">
                  {item}
                </span>
              ))}
            </div>
          </div>

          {/* Right: Clean grounded visual — image card + stats */}
          <div className="flex-1 w-full lg:w-auto flex justify-center lg:justify-end animate-on-scroll">
            <div className="w-full max-w-[440px]">
              {/* Main image card */}
              <div className="relative rounded-2xl overflow-hidden border border-white/15 bg-white/5 backdrop-blur-md">
                <img
                  src={Techbridge2}
                  alt="IT Infrastructure"
                  className="w-full h-[260px] md:h-[300px] object-cover"
                />
                {/* Bottom overlay bar inside image */}
                <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/80 to-transparent p-4 md:p-5">
                  <p className="font-label text-xs text-white/70 uppercase tracking-wider">Trusted IT Partner</p>
                  <p className="text-sm text-white font-medium mt-0.5">Chennai & Surrounding Areas</p>
                </div>
              </div>

              {/* Stats row below image */}
              <div className="grid grid-cols-3 gap-3 mt-4">
                <div className="rounded-xl border border-white/10 bg-white/5 backdrop-blur-sm p-3 md:p-4 text-center hover:border-primary-500/40 transition-colors duration-300">
                  <p className="font-heading text-lg md:text-xl font-bold text-white">500+</p>
                  <p className="font-label text-[10px] md:text-xs text-white/50 uppercase tracking-wider mt-1">Devices</p>
                </div>
                <div className="rounded-xl border border-white/10 bg-white/5 backdrop-blur-sm p-3 md:p-4 text-center hover:border-primary-500/40 transition-colors duration-300">
                  <p className="font-heading text-lg md:text-xl font-bold text-white">150+</p>
                  <p className="font-label text-[10px] md:text-xs text-white/50 uppercase tracking-wider mt-1">Networks</p>
                </div>
                <div className="rounded-xl border border-white/10 bg-white/5 backdrop-blur-sm p-3 md:p-4 text-center hover:border-primary-500/40 transition-colors duration-300">
                  <p className="font-heading text-lg md:text-xl font-bold text-white">24/7</p>
                  <p className="font-label text-[10px] md:text-xs text-white/50 uppercase tracking-wider mt-1">Support</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}